import React from 'react';
import './ReportDataTable.css';

const ReportDataTable = ({ reportData }) => {
  if (!reportData) {
    return (
      <div className="no-data">
        <div className="no-data-icon">📊</div>
        <p>Nenhum relatório selecionado</p>
        <span>Selecione um relatório na lista ao lado para visualizar os dados</span>
      </div>
    );
  }

  const { reportName, headers, rows } = reportData;

  // Função para normalizar nomes de colunas
  const normalizeHeaderName = (header) => {
    if (!header) return '';
    
    return header
      .replace(/[_-]/g, ' ') // Substitui _ e - por espaços
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Adiciona espaço antes de maiúsculas
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const normalizedHeaders = headers ? headers.map(normalizeHeaderName) : [];

  if (!rows || rows.length === 0) {
    return (
      <div className="report-content">
        <div className="report-header">
          <h3>{reportName || 'Relatório'}</h3>
        </div>
        <div className="no-data">
          <div className="no-data-icon">📋</div>
          <p>Nenhum dado encontrado</p>
          <span>Este relatório não possui dados para exibir</span>
        </div>
      </div>
    );
  }

  return (
    <div className="report-content">
      <div className="report-header">
        <h3>{reportName || 'Relatório'}</h3>
        <div className="report-stats">
          <span className="stat">
            {rows.length} registro{rows.length !== 1 ? 's' : ''}
          </span>
          {normalizedHeaders.length > 0 && (
            <span className="stat">
              {normalizedHeaders.length} coluna{normalizedHeaders.length !== 1 ? 's' : ''}
            </span>
          )}
        </div>
      </div>

      <div className="table-container">
        <table className="report-table">
          <thead>
            <tr>
              {normalizedHeaders.map((header, index) => (
                <th key={index} className="table-header">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="table-row">
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex} className="table-cell">
                    {cell !== null && cell !== undefined ? String(cell) : '-'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportDataTable;
